import { ReactNode } from 'react'
import { Box, Fade, SxProps } from '@mui/material'

type LeftBorderedBoxProps = {
  children: ReactNode
  color: string
  showMiniBorder?: boolean
  sx?: SxProps
}

export default function LeftBorderedBox({
  children,
  color,
  showMiniBorder,
  sx,
}: LeftBorderedBoxProps) {
  return (
    <Box
      sx={{
        width: '100%',
        '&::before': {
          content: '""',
          transition: 'all 0.1s',
          width: 4,
          background: color,
          display: 'inline-block',
          height: '90%',
          position: 'absolute',
          top: '5%',
          left: 0,
        },
        ...sx,
      }}
    >
      <Fade in={showMiniBorder} timeout={250} unmountOnExit mountOnEnter>
        <Box
          component="span"
          sx={{
            '@keyframes shrinkGrow': {
              '0%': { height: '70%', top: '15%' },
              '50%': { height: '40%', top: '30%' },
              '100%': { height: '70%', top: '15%' },
            },
            transition: 'height 0.5s ease-in-out',
            width: 4,
            background: color,
            display: 'inline-block',
            position: 'absolute',
            left: -6,
            animation: 'shrinkGrow 2.5s infinite',
            borderRadius: 2,
          }}
        />
      </Fade>
      {children}
    </Box>
  )
}
